import { useMutation } from 'react-query'
import axios from 'axios'

const ENDPOINT = `/api/hoof-application`
const QUERY_KEY = 'application'

export const usePostApplication = (config = {}) =>
  useMutation((data) => axios.post(`${ENDPOINT}/create-application`, data), config)
